import { Alert, Box, Button, Center, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react'
import { useColorModeValue } from './ui/color-mode'
import nygovLogo from '../assets/nygov-logo.png'
import { login } from '@/api';

interface LoginProps { 
    fontFamily?: string;
}

export const Login = (props: LoginProps) => {

    const {fontFamily} = props;

    const handleLogin = () => {
        login();
    };

    return (
        <Center fontFamily={fontFamily} height="100vh" bg={useColorModeValue('gray.50', 'gray.900')}>
            <Box
                p={8}
                maxWidth="400px"
                borderWidth={1}
                borderRadius={8}
                boxShadow="lg"
                bg={useColorModeValue('white', 'gray.800')}
            >
                <VStack gap={6} align="stretch">
                    <Center>
                        <Image src={nygovLogo} alt="NY.gov Logo" height="60px" />
                    </Center>

                    {window.location.pathname === '/logout' && (
                        <Alert.Root status="info">
                        <Alert.Indicator />
                        <Alert.Content>
                            <Alert.Title>You have been logged out.</Alert.Title>
                        </Alert.Content>
                        </Alert.Root>
                    )}

                    <Stack fontFamily={'proxima nova'} gap={2} textAlign="center">
                        <Heading fontFamily={fontFamily} size="xl">Welcome</Heading>
                        <Text color="fg.muted">Please sign in to access the application</Text>
                    </Stack>
                    <Button
                        colorPalette="blue"
                        size="lg"
                        onClick={handleLogin}
                        fontWeight="bold"
                    >
                        Sign in to ny.gov
                    </Button>
                </VStack>
            </Box>
        </Center>
    );
};
